class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover)').matches) return;
      clearTimeout(this.hoverCloseTimer);
      this.parentElement.parentElement.querySelectorAll(':scope > li > header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
      this.mainDetailsToggle.open = true;
    });
    this.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      this.hoverCloseTimer = setTimeout(() => {
        if (!this.content.contains(document.activeElement)) this.close();
      }, 200);
    });
    this.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      event.stopPropagation();
      if (!this.mainDetailsToggle.open) return;
      this.close();
      this.mainDetailsToggle.querySelector('summary').focus();
    });
  }

  disconnectedCallback() {
    clearTimeout(this.hoverCloseTimer);
  }

  close() {
    clearTimeout(this.hoverCloseTimer);
    this.querySelectorAll('header-menu').forEach((menu) => menu.close());
    super.close();
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu > details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
